import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

const AdminForceRender = () => {
  const [uid, setUid] = useState('');
  const [mid, setMid] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Clear previous messages
    setMessage('');
    setError('');

    // Validate inputs
    if (!uid.trim() || !mid.trim()) {
      setError('Both UID and MID are required');
      return;
    }

    setLoading(true);

    try {
      const forceRenderMovie = httpsCallable(getFunctions(), 'forceRenderMovie');
      const result = await forceRenderMovie({ 
        uid: uid.trim(), 
        mid: mid.trim() 
      });
      
      setMessage(result.data.message);
      setUid('');
      setMid('');
    } catch (err) {
      setError(err.message || 'Failed to initiate movie render');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-xl font-bold text-gray-900 mb-4">Force Movie Render</h2>
      <p className="text-gray-600 mb-6">
        Force render a movie by providing the UID and MID. This will bypass existence checks and initiate rendering immediately.
      </p>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="uid" className="block text-sm font-medium text-gray-700 mb-2">
            UID
          </label>
          <input
            type="text"
            id="uid"
            value={uid}
            onChange={(e) => setUid(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Enter user UID"
            disabled={loading}
          />
        </div>
        
        <div>
          <label htmlFor="mid" className="block text-sm font-medium text-gray-700 mb-2">
            MID
          </label>
          <input
            type="text"
            id="mid"
            value={mid}
            onChange={(e) => setMid(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Enter movie MID"
            disabled={loading}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Initiating Render...' : 'Force Render Movie'}
        </button>
      </form>

      {message && (
        <div className="mt-4 p-3 rounded-md bg-green-100 text-green-700">
          {message}
        </div>
      )}

      {error && (
        <div className="mt-4 p-3 rounded-md bg-red-100 text-red-700">
          {error}
        </div>
      )}
    </div>
  );
};

export default AdminForceRender;
